import React, { useState } from 'react';
import unavailableCover1 from '../../images/cover-unavaliable-1.png';
import unavailableCover2 from '../../images/cover-unavaliable-2.png';
import unavailableCover3 from '../../images/cover-unavaliable-3.png';
import ImageFadeIn from "react-image-fade-in";

const fallbackCovers = [unavailableCover1, unavailableCover2, unavailableCover3];

const BookDefaultCover = ({ coverUrl, alt }) => {
    const [defaultCover] = useState(() => fallbackCovers[Math.floor(Math.random() * fallbackCovers.length)]);

    const fallbackImg = e => {
        e.target.onerror = null;
        e.target.src = defaultCover;
        e.target.style.opacity = 1;
    }

    return(
        <ImageFadeIn onError={(e) => fallbackImg(e)} src={coverUrl || defaultCover} alt={`Cover for ${alt}`} />
    )
}

export default BookDefaultCover;
